import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const PriceImpactTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>{t('The difference between the market price and estimated price due to trade size.')}</TooltipBase>
  )
}
